<template>
    <div>
        <el-container>
            <el-header>
                <header :class="{ 'menu': isScrolled }">
                    <CNavMenu></CNavMenu>
                </header>
            </el-header>
            <el-main>
                <router-view></router-view>
            </el-main>
            <el-footer>
                <CFooter></CFooter>
            </el-footer>
        </el-container>
    </div>
</template>

<script>

export default {
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    data() {
        return {
            isScrolled: false
        }
    },
    methods: {
        handleScroll() {
            const scrolled = window.scrollY
            if (scrolled > 100) { // 滚动距离大于100时改变背景颜色
                this.isScrolled = true
            } else {
                this.isScrolled = false
            }
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }
}
</script>

<style lang="scss" scoped>
header {
    overflow: hidden;
    width: 100vw;
    height: 8rem;
    position: fixed;
    top: 0;
    z-index: 9999;
    transition: background-color 0.3s ease-in-out;
    /* 添加过渡效果 */
}

header.menu {
    background-color: rgba(0, 0, 0, 0.5);
    /* 滚动后的背景颜色 */
}
</style>